export class Notification {
  type: NotificationType;
  message: string;
  header: string;
}

export enum NotificationType {
  Success,
  Error,
  Info,
  Warning,
}
